import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  getAreaSelect,
  getEquipmentSelect,
  saveItem,savedatauser,
} from "./../../services/fire";
import Select from "../common/selectcustom";
import Toggle from "../common/toggle";
import dlv from "dlv";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FormInput } from "../common/forminput";
import Input from "../common/inputfunction";
import FontAwesome from "react-fontawesome";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

const Adduser = ({
  button1,
  isOpen,
  header,
  onCancel,
  onconfirm,
  value,
  list,restatus,
}) => {
  let status;
  try {
    const ojb1 = value;
    status = dlv(ojb1, "status", true);
  } catch {}

  let editid;
  let name;

  let empid;

  try {
    const ojb = list[0];
    editid = dlv(ojb, "_id", "0");
    name = dlv(ojb, "name", "");
    empid = dlv(ojb, "empid", "");
  } catch {}
  const PreloadedValues = {
    id: editid,
    item: name,
    empid: empid,
  };

  const [error, seterror] = useState("");
  const [autoid, setautoid] = useState(0);
  const [pempid, setpempid] = useState("");
  const [disable, setdisable] = useState(false);
  const [equipmentid, setequipmentid] = useState(0);
  const [enabled, setenabled] = useState(true);
  const [nowDate, setNowDate] = useState(new Date());
  const [openUpload, setopenUpload] = useState(false);
  const [toggle, settoggle] = useState({
    nonpower: { isChecked: false, text: "สิทธิ์ Non Power" },
    powergroup: { isChecked: false, text: "สิทธิ์ กลุ่มPower" },
  });

  const { register, errors,reset, handleSubmit, setValue } = useForm({
    mode: "onSubmit",
    //  defaultValues: PreloadedValues,
  });

  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });

  useEffect(() => {
    if (list.length > 0) {
      settoggle({
        nonpower: { isChecked: list[0].nonpower, text: "สิทธิ์ Non Power" },
        powergroup: {
          isChecked: list[0].powergroup,
          text: "สิทธิ์ กลุ่มPower",
        },
      });
    }
  }, [list]);

  useEffect(() => {
    setdisable(!status);
  }, [status]);

  const handleChangeToggle = (e) => {
    //  console.log("e.target",e.target)
    const { id, checked } = e.target;
    const name = toggle[id].text;

    const Id = {
      text: name,
      isChecked: checked,
    };
    settoggle((prevToggle) => {
      return {
        ...prevToggle,
        [id]: Id,
      };
    });
 
  };

  const handleEmpChange = (event) => {
    setpempid(event.currentTarget.value);
  };
  const handleKeyPress = () => {};
  const handleSearchClick = () => {};

  const onSubmit = (data) => {
    seterror("");
    if (! list){
      toast.error("ไม่พบข้อมูลค่ะ..");
    return
    }
    if (! list.length > 0){
      toast.error("ไม่พบข้อมูลค่ะ..");
    return
    }
    const saveobject = [{
      empid: list[0].empid,
      Pulp : toggle.nonpower.isChecked ,power : toggle.powergroup.isChecked,
      ...data,
    }];
 
    SaveData(saveobject);
    
  };
  //console.log("test",list)
  const SaveData = async (doc) => {
 
    const { data: result } = await savedatauser(doc);

    if (result.status == "success") {
      toast.success("บันทึกเรียบร้อยค่ะ");
      //date(setNowDate)
      restatus(true)
      onCancel(false);
    } else {
       toast.error(result.message);
    }

  };

  const handleTextchange = () => {
    setdisable(!disable);
  };
  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div>
        <Modal
          isOpen={isOpen}
          toggle={onCancel}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ModalHeader>
            <FontAwesome name="pencil-square-o"> </FontAwesome> {header}
          </ModalHeader>
          <ModalBody>
            {list == 0 && (
              <div className="row">
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <div className="form-group">
                    <div className="from-group">
                      <label htmlFor="devicename">ชื่อ-รหัสพนักงาน </label>
                      <div className="input-group">
                        <Input
                          value={pempid}
                          onChange={handleEmpChange}
                          onKeyPress={handleKeyPress}
                          onClick={handleSearchClick}
                          placeholder="รหัส/ชื่อ เพื่อค้นหา"
                          search="ค้นหา"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {list && list.length > 0 && (
              <div className="row">
                <div className="container-fluid">
                  <div className="card border-secondary m-1">
                    <div className="card-body">
                      <div className="row">
                        <div className="container col-xs-12 col-sm-6">
                          <div
                            className="border border-top-0 border-right-0 border-left-0"
                            style={{ fontSize: 15 }}
                          >
                            <span className="badge badge-pill badge-secondary">
                              1
                            </span>
                          </div>
                          <div
                            className="border border-top-0 border-right-0 border-left-0"
                            style={{ fontSize: 14 }}
                          >
                            {" "}
                            รหัสพนักงาน: {list[0].empid}
                          </div>
                          <div
                            className="border border-top-0 border-right-0 border-left-0"
                            style={{ fontSize: 14 }}
                          >
                            ชื่อ: {list[0].name}
                          </div>
                          <div
                            className="border border-top-0 border-right-0 border-left-0"
                            style={{ fontSize: 15 }}
                          >
                            แผนก :{list[0].department}
                          </div>
                          {/* <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: 15 }}
                        >
                          เบอร์โทร :085-8354556
                        </div> */}
                        </div>
                        <div className="container col-xs-12 col-sm-6">
                          <div
                            className="border border-top-0 border-right-0 border-left-0"
                            style={{ fontSize: 14 }}
                          >
                            <div className="col-sm-6 my-1">
                            <Toggle
                                name="powergroup"
                                checked={toggle.powergroup.isChecked}
                                onChange={handleChangeToggle}
                                text={toggle.powergroup.text}
                              />
                              <Toggle
                                name="nonpower"
                                checked={toggle.nonpower.isChecked}
                                onChange={handleChangeToggle}
                                text={toggle.nonpower.text}
                              />
                          
                            </div>
                          </div>

                          <div>
                            {/* {
                              <div className="form-check col-sm-3 my-3">
                                <label
                                  className="form-check-label"
                                  htmlFor="defaultCheck2"
                                >
                                  ยกเลิกสิทธิ์
                                </label>
                                <input
                                  className="form-check-input ml-4"
                                  type="checkbox"
                                  defaultValue
                                  id="defaultCheck2"
                                  style={{ width: 25, height: 25 }}
                                />
                              </div>
                            } */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-sm-4 col-xs-12"></div>
            </div>
          </ModalBody>
          {error && (
            <div className="col-md-12 alert alert-danger"> {error}</div>
          )}

          {list && list.comment && (
            <Button color="danger">{list.comment}</Button>
          )}
          <ModalFooter>
            {enabled && (
              <Button color="primary" onClick={handleSubmit(onSubmit)}>
                {button1}
              </Button>
            )}

            <Button color="secondary" onClick={onCancel}>
              ยกเลิก
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </form>
  );
};

export default Adduser;
